import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ReceiptControllerService } from '../api/services';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';

import { PaymentResponseDto } from '../api/models';

@Component({
  selector: 'app-status',
  imports: [
    ReactiveFormsModule
],
  templateUrl: './status.component.html',
  styleUrl: './status.component.css'
})
export class StatusComponent implements OnInit{
  
  
  referenceVersus?:string;
  referenceBank?:string;
  bank?:string;
  status?:string;
  result?:PaymentResponseDto;
  action:string='';
  resultForm:FormGroup;
  sendForm=false;

  constructor(
    private formBuilder:FormBuilder,
    private activeRoute:ActivatedRoute,
    private router:Router,
    private receiptService:ReceiptControllerService
  ){
    this.resultForm = this.formBuilder.group({
      requestId:[''],
      reference:[''],
      status:[]
    });
  }
  
  ngOnInit(): void {
    this.activeRoute.params.subscribe(p =>{
      console.log(p);
      this.referenceVersus =p['reference'];
      this.bank =p['bank'];
      this.status =p['currentStatus'];
      }); 
      this.activeRoute.queryParams.subscribe(par=>{
        this.referenceBank = par['ref'];
      });
      this.finalizePayment();
  }
  

  finalizePayment(){
    console.log(this.referenceBank);
    console.log(this.referenceVersus);
    console.log(this.status);
    this.receiptService.getPaymentDetails(
      this.referenceVersus!!
    ).subscribe({
      next:(resp)=>{
        console.log(resp);
        if(this.status?.toUpperCase() =='PENDING' && resp.status!='PENDING'){
          this.status=resp.status;
        }
        if(this.status =='PENDING'){
          setTimeout(()=>
            {
              this.finalizePayment();
            },
            20000);
        }else {
          this.sendResult(resp);
          //
        }
        
      },
      
    });
   
  }
  sendResult(resp:PaymentResponseDto){
    console.log('send result');
    let finalStatus='FAILED';
    if(this.status?.toLowerCase()=='success'||this.status?.toLowerCase()=='paid'||this.status?.toLowerCase()=='validated'){
      finalStatus ='PAID';
    }
    if(resp.returnUrl ==null ||resp.returnUrl.length==0){
      this.router.navigateByUrl('receipt/'+this.referenceVersus+'/'+finalStatus);
    }else {
    this.action = resp.returnUrl?resp.returnUrl:'receipt';
    this.resultForm.controls['requestId'].setValue(resp.requestId);
    this.resultForm.controls['reference'].setValue(resp.reference);
    this.resultForm.controls['status'].setValue(resp.status);
    

    this.action = this.action+'?reference='+resp.reference+'&requesId='+resp.requestId;
    this.action=this.action+'&status='+finalStatus;

    window.open(this.action,'_self');
}
  }

}
